import { CLIENT_ID } from '../../../Config/config'
import React, { useState, useEffect } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import authService from '../../api-authorization/AuthorizeService'
import axios from 'axios'
import { Stack, Alert, Paper, Box, Accordion, AccordionSummary, AccordionDetails, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';

const SupporterDonate = () => {
    const [showPayPalButton, setShowPayPalButton] = useState(false);
    const [success, setSuccess] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("");
    const [orderID, setOrderID] = useState();
    const [paymentID, setPaymentID] = useState();
    const [paymentStatus, setPaymentStatus] = useState("");
    const [payerID, setPayerID] = useState();
    const [facilitatorAccessToken, setFacilitatorAccessToken] = useState();
    const [transactionID, setTransactionID] = useState(false);
    const [token, setToken] = useState("");
    const [discription, setDiscription] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogText, setDialogText] = useState("");
    const [myName, setMyName] = useState("");


    const apiPath = '/api/NACHUsers/SupporterDonate';

    const history = useHistory();

    useEffect(async () => {
        var isLoggedIn = await authService.isAuthenticated();
        if (isLoggedIn) {
            var tk1 = await authService.getAccessToken();
            await setToken(tk1);

            var headers = {
                headers: { 'Authorization': `Bearer ${tk1}` }
            }
            var tmpName = "";
            await axios.get('/api/NACHUsers/GetMyName', headers).then((response) => {
                tmpName = response.data;
                setMyName(response.data);
            }).catch((error) => {
                console.log(JSON.stringify(error));
            });

            var user = await authService.getUser();
            var desc = tmpName +" ["+user.sub + "] Supports MetaDB 1 Year";
            setDiscription(desc);
        }
    }, []);

    const UpdateMySupporterDonation = async () => {
        var headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        }

        const formData = new FormData();
        formData.append("orderID", orderID);
        formData.append("payerID", payerID);
        formData.append("facilitatorAccessToken", facilitatorAccessToken);
        
        //https://forum.strapi.io/t/solved-new-version-axios-post-request-responces-400-bad-request/16081
        //https://stackoverflow.com/questions/72307388/axioserror-request-failed-with-status-code-400-in-react-js
        //400 error - bad reqeust - caused by missing or invalid field
        try {
            const res = await axios.post('/api/NACHUsers/SupporterDonate', formData, headers);
            return res.data;
        } catch (e) {
            console.log(e);
            return null;
        }

    };

    // creates a paypal order
    const createOrder = (data, actions) => {
        return actions.order.create({
            purchase_units: [
                {
                    description: discription,
                    amount: {
                        currency_code: "USD",
                        value: 65,
                    },
                },
            ],
        }).then((orderID) => {
            setOrderID(orderID);
            return orderID;
        });
    };

    // check Approval
    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            const { payer } = details;
            setOrderID(data.orderID);
            setPaymentID(data.paymentID);
            setPaymentStatus(details.status);
            setPayerID(data.payerID);
            setFacilitatorAccessToken(data.facilitatorAccessToken);
            setSuccess(true);
        });
    };

    //capture likely error
    const onError = (data, actions) => {
        setErrorMessage("An Error occured with your payment");
    };

    useEffect(async () => {
        if (success) {
            var updateResult = await UpdateMySupporterDonation(token, orderID);
            if (updateResult != null) {
                setShowPayPalButton(false);
                var utcDate = updateResult.supporterStatusExpDateUtc;
                var localDate = new Date(utcDate);
                setDialogTitle("Success");
                setDialogText("Payment successful!! Order ID #" + orderID + " - you are supporter till " + localDate);
                setOpenDialog(true);
            }
            else {
                setDialogTitle("Error!");
                setDialogText("Payment failed. Please contact metadbchess@gmail.com");
                setOpenDialog(true);
            }
        }
    }, [success]);


    const handleCloseDialog = () => {
        setOpenDialog(false);
        history.push("/");
    };

    return (
        <PayPalScriptProvider options={{ "client-id": CLIENT_ID }}>
            <div>
                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                    <Typography color='primary'>Help MetaDB to become the best Chess Database on the Internet!</Typography>
                </Stack>
                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                    <Typography color='primary'>By supporting us $50/year, you will get following benefits - </Typography>
                </Stack>
                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                    <Typography color='primary' component="div">
                        <ul>
                            <li>Download 12 PGN's every 24 hours (Starting Jan 1st 2026, it will be 4 PGN's very 12 hours)</li>
                            <ul>
                                <li>Non-supporters can only download 1 PGN every 24 hours</li>
                            </ul>
                            <li>Access newest games in MetaDB</li>
                            <ul>
                                <li>New games are being added to MetaDB every hour</li>
                                <li>Supporters can download or view newest games once they are in MetaDB</li>
                                <li>Non-supporters can not download or view games of current year [{new Date().getFullYear()}] and the year before [{new Date().getFullYear()-1}] </li>
                            </ul>
                            <li>Protection of PGN and Games</li>
                            <ul>
                                <li>Non-supporters can not download PGN of supporters</li>
                                <li>Non-supporters can not view games of supporters</li>
                                <li>Only supporters can view/download other supporters' games</li>
                            </ul>
                            <li>Supporter-only features</li>
                            <ul>
                                <li>Filter blitz games from PGN</li>
                                <li>Search games with similar names</li>
                                <li>Notification of PGN being downloaded</li>
                                <li>Download online games from Chess.com and Lichess.org</li>
                            </ul>
                        </ul>
                    </Typography>
                </Stack>



                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                    <Button variant='contained' onClick={() => setShowPayPalButton(true)}>
                        Donate $65 Now
                    </Button>
                    <Link to="/">
                        <Button variant='contained' color='secondary'>
                            Cancel
                        </Button>
                    </Link>
                </Stack>
                <Stack>
                    {showPayPalButton ? (
                        <PayPalButtons
                            style={{ layout: "vertical" }}
                            createOrder={createOrder}
                            onApprove={onApprove}
                        />
                    ) : null}
                </Stack>



                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-eventDescription"
                >
                    <DialogTitle id="alert-dialog-title">
                        {dialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-eventDescription">
                            {dialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>



        </PayPalScriptProvider>
    );
}

export default SupporterDonate